export default __webpack_public_path__ + "static/media/ic-play.94e35017.svg";